/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Scope_Api_Read_DescInputs */



/**
* | output |
* | --- |
* | "Read the public data API as a daemon (no user)" |
*
* @param {Developer_Scope_Api_Read_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_scope_api_read_desc = /** @type {((inputs?: Developer_Scope_Api_Read_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Scope_Api_Read_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lire l'API de données publiques en tant que démon (sans utilisateur)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Leer la API de datos públicos como demonio (sin usuario)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ler a API de dados públicos como daemon (sem usuário)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Leggere l'API di dati pubblici come demone (senza utente)")
	return /** @type {LocalizedString} */ ("Read the public data API as a daemon (no user)")
});